// Traducciones de /sostenibilidad (spec 025, INI-1167). Cada entrada es [es, en, pt-BR].
export const sostenibilidadMessages = Object.fromEntries(
  [
    // Menú y encabezado
    ['Sostenibilidad', 'Sustainability', 'Sustentabilidade'],
    ['SOSTENIBILIDAD', 'SUSTAINABILITY', 'SUSTENTABILIDADE'],
    ['Percepción de sostenibilidad en IA', 'Sustainability perception in AI', 'Percepção de sustentabilidade na IA'],
    ['Cómo presenta la IA ', 'How AI presents ', 'Como a IA apresenta '],
    ['la sostenibilidad de tu empresa.', 'your company’s sustainability.', 'a sustentabilidade da sua empresa.'],
    [
      'Medimos qué dicen ChatGPT, Claude y Gemini de tu empresa en clima, agua, ecosistemas, comunidades, personas y gobernanza, frente a tu industria. Es el primer monitoreo recurrente de este tipo en Latinoamérica.',
      'We measure what ChatGPT, Claude and Gemini say about your company on climate, water, ecosystems, communities, people and governance, compared with your industry. It is the first recurring monitoring of its kind in Latin America.',
      'Medimos o que ChatGPT, Claude e Gemini dizem da sua empresa em clima, água, ecossistemas, comunidades, pessoas e governança, frente ao seu setor. É o primeiro monitoramento recorrente desse tipo na América Latina.',
    ],
    ['Ver el ranking', 'See the ranking', 'Ver o ranking'],
    ['Pilares', 'Pillars', 'Pilares'],
    ['Clima, agua, comunidades y más', 'Climate, water, communities and more', 'Clima, água, comunidades e mais'],
    ['Motores', 'Engines', 'Motores'],
    ['ChatGPT, Claude y Gemini', 'ChatGPT, Claude and Gemini', 'ChatGPT, Claude e Gemini'],
    ['Comparación', 'Comparison', 'Comparação'],
    ['Tu industria', 'Your industry', 'Seu setor'],
    ['Frente a tus pares', 'Against your peers', 'Frente aos seus pares'],
    ['Trimestral', 'Quarterly', 'Trimestral'],
    ['Para ver si cambia', 'To see if it changes', 'Para ver se muda'],
    // 01 · Qué medimos
    ['01 / Qué medimos', '01 / What we measure', '01 / O que medimos'],
    ['Seis pilares,', 'Six pillars,', 'Seis pilares,'],
    ['frente a tu industria.', 'against your industry.', 'frente ao seu setor.'],
    [
      'Las mismas preguntas que se hacen sobre tu sector, a ChatGPT, Claude y Gemini. Registramos a quién nombra la IA y cómo describe a cada empresa en cada pilar.',
      'The same questions people ask about your sector, put to ChatGPT, Claude and Gemini. We record whom the AI names and how it describes each company in each pillar.',
      'As mesmas perguntas que se fazem sobre o seu setor, feitas ao ChatGPT, Claude e Gemini. Registramos quem a IA cita e como descreve cada empresa em cada pilar.',
    ],
    ['Clima', 'Climate', 'Clima'],
    ['Clima y energía', 'Climate and energy', 'Clima e energia'],
    [
      'Si la IA asocia tu empresa con metas de emisiones, energía limpia y eficiencia, o si nombra a otra cuando se le pregunta por eso.',
      'Whether AI links your company to emission targets, clean energy and efficiency, or names another company when asked about it.',
      'Se a IA associa sua empresa a metas de emissões, energia limpa e eficiência, ou se cita outra quando perguntam sobre isso.',
    ],
    ['Comunidades', 'Communities', 'Comunidades'],
    ['Comunidades y territorio', 'Communities and territory', 'Comunidades e território'],
    [
      'Cómo describe la IA tu relación con las comunidades y los territorios donde operas.',
      'How AI describes your relationship with the communities and territories where you operate.',
      'Como a IA descreve sua relação com as comunidades e os territórios onde você opera.',
    ],
    ['Ecosistemas', 'Ecosystems', 'Ecossistemas'],
    ['Ecosistemas y residuos', 'Ecosystems and waste', 'Ecossistemas e resíduos'],
    ['Agua', 'Water', 'Água'],
    ['Qué dice la IA de cómo usas y cuidas el agua en tus operaciones.', 'What AI says about how you use and protect water in your operations.', 'O que a IA diz de como você usa e cuida da água nas suas operações.'],
    [
      'Qué dice de tu manejo de los residuos y de los ecosistemas donde trabajas.',
      'What it says about how you manage waste and the ecosystems where you work.',
      'O que diz da sua gestão dos resíduos e dos ecossistemas onde você trabalha.',
    ],
    ['Gobernanza', 'Governance', 'Governança'],
    ['Gobernanza y transparencia', 'Governance and transparency', 'Governança e transparência'],
    [
      'Si la IA te presenta como una empresa transparente, con reportes y compromisos que se pueden verificar.',
      'Whether AI presents you as a transparent company, with reports and commitments that can be verified.',
      'Se a IA apresenta você como uma empresa transparente, com relatórios e compromissos que podem ser verificados.',
    ],
    ['Personas', 'People', 'Pessoas'],
    ['Personas y trabajo', 'People and work', 'Pessoas e trabalho'],
    [
      'Cómo aparecen en las respuestas tus condiciones laborales, la seguridad y la diversidad de tu equipo.',
      'How your working conditions, safety and team diversity show up in the answers.',
      'Como aparecem nas respostas suas condições de trabalho, a segurança e a diversidade da sua equipe.',
    ],
    [
      'El ranking de sustentabilidad en IA muestra a qué empresas favorece la IA en cada industria de Chile.',
      'The AI sustainability ranking shows which companies AI favors in each industry in Chile.',
      'O ranking de sustentabilidade na IA mostra quais empresas a IA favorece em cada setor do Chile.',
    ],
    ['Ver el ranking de sustentabilidad', 'See the sustainability ranking', 'Ver o ranking de sustentabilidade'],
    // 02 · El ciclo
    ['02 / El ciclo', '02 / The cycle', '02 / O ciclo'],
    ['Medir, explicar,', 'Measure, explain,', 'Medir, explicar,'],
    ['actuar y verificar.', 'act and verify.', 'agir e verificar.'],
    [
      'Un ciclo que se repite cada trimestre, para que la percepción cambie por lo que la empresa hace y no por lo que promete.',
      'A cycle that repeats every quarter, so perception changes because of what the company does, not what it promises.',
      'Um ciclo que se repete a cada trimestre, para que a percepção mude pelo que a empresa faz e não pelo que promete.',
    ],
    ['Medir', 'Measure', 'Medir'],
    [
      'Hacemos a ChatGPT, Claude y Gemini las preguntas que se hacen sobre tu industria y registramos cómo te presentan, pilar por pilar.',
      'We ask ChatGPT, Claude and Gemini the questions people ask about your industry and record how they present you, pillar by pillar.',
      'Fazemos ao ChatGPT, Claude e Gemini as perguntas que se fazem sobre o seu setor e registramos como apresentam você, pilar por pilar.',
    ],
    ['Explicar', 'Explain', 'Explicar'],
    [
      'Mostramos por qué estás donde estás: qué fuentes cita la IA y qué información falta o está desactualizada.',
      'We show why you are where you are: which sources AI cites and what information is missing or outdated.',
      'Mostramos por que você está onde está: quais fontes a IA cita e que informação falta ou está desatualizada.',
    ],
    ['Actuar', 'Act', 'Agir'],
    [
      'Priorizamos qué mejorar y qué comunicar, empezando por las prácticas reales de la empresa.',
      'We prioritize what to improve and what to communicate, starting with the company’s real practices.',
      'Priorizamos o que melhorar e o que comunicar, começando pelas práticas reais da empresa.',
    ],
    ['Verificar', 'Verify', 'Verificar'],
    [
      'Volvemos a medir para ver si la percepción cambió y qué la movió.',
      'We measure again to see whether perception changed and what moved it.',
      'Medimos de novo para ver se a percepção mudou e o que a moveu.',
    ],
    // 03 · Sin greenwashing
    ['03 / Sin greenwashing', '03 / No greenwashing', '03 / Sem greenwashing'],
    ['Primero la mejora,', 'Improvement first,', 'Primeiro a melhoria,'],
    ['después la comunicación.', 'communication second.', 'depois a comunicação.'],
    [
      'No ayudamos a decir más de lo que la empresa hace. Medimos, explicamos y recién entonces comunicamos.',
      'We do not help say more than the company does. We measure, explain and only then communicate.',
      'Não ajudamos a dizer mais do que a empresa faz. Medimos, explicamos e só então comunicamos.',
    ],
    ['Primero, la mejora real', 'First, real improvement', 'Primeiro, a melhoria real'],
    [
      'Si la IA no te reconoce en un pilar, lo primero es revisar la práctica, no el mensaje.',
      'If AI does not recognize you in a pillar, the first step is to review the practice, not the message.',
      'Se a IA não reconhece você em um pilar, o primeiro passo é revisar a prática, não a mensagem.',
    ],
    ['Después, la comunicación', 'Then, communication', 'Depois, a comunicação'],
    [
      'Comunicamos avances que se pueden verificar, con fuentes que la IA pueda citar.',
      'We communicate progress that can be verified, with sources AI can cite.',
      'Comunicamos avanços que podem ser verificados, com fontes que a IA possa citar.',
    ],
    ['Nada negativo con nombre', 'Nothing negative by name', 'Nada negativo com nome'],
    [
      'Lo público muestra a quién favorece la IA. Lo que dice de una empresa en particular queda en su reporte.',
      'What is public shows whom AI favors. What it says about a specific company stays in that company’s report.',
      'O que é público mostra quem a IA favorece. O que ela diz de uma empresa em particular fica no relatório dela.',
    ],
    // 04 · Qué recibes
    ['04 / Qué recibes', '04 / What you get', '04 / O que você recebe'],
    ['Un reporte diagnóstico', 'A diagnostic report', 'Um relatório diagnóstico'],
    ['de tu empresa.', 'on your company.', 'da sua empresa.'],
    [
      'Con los datos de tu industria y de los tres motores. Es privado: lo ve tu empresa.',
      'With data from your industry and the three engines. It is private: only your company sees it.',
      'Com os dados do seu setor e dos três motores. É privado: só sua empresa vê.',
    ],
    ['Posición', 'Position', 'Posição'],
    ['Dónde estás frente a tu industria', 'Where you stand in your industry', 'Onde você está frente ao seu setor'],
    [
      'Cómo te presenta la IA comparado con las empresas de tu sector, en cada motor.',
      'How AI presents you compared with the companies in your sector, in each engine.',
      'Como a IA apresenta você em comparação com as empresas do seu setor, em cada motor.',
    ],
    ['Qué dice de ti, pilar por pilar', 'What it says about you, pillar by pillar', 'O que diz de você, pilar por pilar'],
    [
      'Las respuestas de la IA sobre tu empresa en los seis pilares, con las fuentes que cita.',
      'AI’s answers about your company across the six pillars, with the sources it cites.',
      'As respostas da IA sobre sua empresa nos seis pilares, com as fontes que cita.',
    ],
    ['Próximos pasos', 'Next steps', 'Próximos passos'],
    ['Qué mejorar y qué comunicar', 'What to improve and what to communicate', 'O que melhorar e o que comunicar'],
    [
      'Las brechas entre lo que haces y lo que la IA dice de ti, y por dónde empezar.',
      'The gaps between what you do and what AI says about you, and where to start.',
      'As lacunas entre o que você faz e o que a IA diz de você, e por onde começar.',
    ],
    // 05 · Para quién
    ['05 / Para quién', '05 / Who it is for', '05 / Para quem'],
    ['Para los equipos que', 'For the teams who', 'Para as equipes que'],
    ['responden por la reputación.', 'answer for reputation.', 'respondem pela reputação.'],
    [
      'Sostenibilidad, comunicaciones, el directorio y los gremios de cada industria.',
      'Sustainability, communications, the board and each industry’s trade associations.',
      'Sustentabilidade, comunicação, o conselho e as associações de cada setor.',
    ],
    [
      'Para saber si tu trabajo se ve fuera de la empresa y qué fuentes lo cuentan.',
      'To know whether your work is visible outside the company and which sources tell it.',
      'Para saber se seu trabalho é visto fora da empresa e quais fontes o contam.',
    ],
    ['Comunicaciones', 'Communications', 'Comunicação'],
    [
      'Para comunicar avances reales con datos de cómo te ve la IA, sin prometer lo que no puedes sostener.',
      'To communicate real progress with data on how AI sees you, without promising what you cannot sustain.',
      'Para comunicar avanços reais com dados de como a IA vê você, sem prometer o que não pode sustentar.',
    ],
    ['Directorio', 'Board', 'Conselho'],
    [
      'Para seguir un indicador externo de reputación en sostenibilidad, trimestre a trimestre.',
      'To track an external sustainability reputation indicator, quarter by quarter.',
      'Para acompanhar um indicador externo de reputação em sustentabilidade, trimestre a trimestre.',
    ],
    ['Gremios', 'Trade associations', 'Associações setoriais'],
    [
      'Para ver cómo presenta la IA a tu industria completa y dónde está la brecha común.',
      'To see how AI presents your whole industry and where the shared gap is.',
      'Para ver como a IA apresenta todo o seu setor e onde está a lacuna comum.',
    ],
    // Cierre
    ['Diagnóstico', 'Diagnosis', 'Diagnóstico'],
    ['Mira cómo te presenta la IA ', 'See how AI presents you ', 'Veja como a IA apresenta você '],
    ['en sostenibilidad.', 'on sustainability.', 'em sustentabilidade.'],
    // Hub de rankings de sustentabilidad: enlace de vuelta
    [
      'Para saber cómo te presenta la IA a ti y qué hacer con eso, mira el diagnóstico de sostenibilidad.',
      'To learn how AI presents you and what to do about it, see the sustainability diagnosis.',
      'Para saber como a IA apresenta você e o que fazer com isso, veja o diagnóstico de sustentabilidade.',
    ],
    ['Ver sostenibilidad en Bison', 'See sustainability at Bison', 'Ver sustentabilidade na Bison'],
  ].map(([es, ...traducciones]) => [es, traducciones]),
);
